import { AxiosRequestConfig } from 'axios';

export const createAbortController = (config: AxiosRequestConfig) => {
    let controller: AbortController | undefined;
    return {
        create: () => {
            controller = new AbortController();
            config.signal = controller.signal;
        },
        cancel: () => {
            if (controller) {
                controller.abort();
            }
        }
    };
};
